<template>
  <b-modal @hide="modalClose" ref="csvModal" :title="modalTitle" size="lg">
    <b-container fluid>
      <table class="table table-bordered my-3">
        <tbody class="tbody">
          <tr>
            <th class="table-active text-left">{{ modalTitle }}</th>
            <td class="text-left">
              <select v-model="form.importSettingId" name="" id="" class="form-control">
                <option value="">-</option>
                <option v-for="(item, index) in settings" :key="index" :value="item.id">{{ item.name }}</option>
              </select>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('ファイル') }}</th>
            <td class="text-left" colspan="5">
              <input id="csvFile" ref="csvFile" type="file" @change="handleFile" class="form-control-file">
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('データ件数') }}</th>
            <td class="text-left" colspan="5">
              <template v-if="!isEmpty(_dataNum) && !isEmpty(form.importSettingId) && setting.importValues && setting.importValues.length">
                {{ _dataNum }}&nbsp;{{$t('件')}}
              </template>
              <template v-else-if="setting.importValues && setting.importValues.length === 0">
                0&nbsp;{{$t('件')}}
              </template>
              <template v-else>
                -
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </b-container>
    <template v-slot:modal-footer>
      <p class="text-danger text-center" v-if="_error">{{ _error }}</p>
      <div class="d-flex justify-content-center align-items-center mt-4 mb-4 w-100">
        <button
          type="button"
          class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
          :disabled="registering || !_dataNum || _dataNum > 1000 || isEmpty(form.importSettingId)"
          @click="register()"
        >
          <div
            class="d-flex justify-content-center align-items-center mr-3"
            v-if="registering"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
          {{ $t('登録') }}
        </button>
        <button
          type="button"
          class="btn btn-light"
          :disabled="registering"
          @click="modalClose()"
        >{{ $t('キャンセル') }}</button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment/moment'
const defaultFormat = {
  importSettingId: null,
  type: '',
  s3Key: '',
  fileName: '',
  userId: 0,
  comment: '',
  registerDate: (new moment()).format('YYYY-MM-DD'),
}
export default {
  data() {
    return {
      form: {
        importSettingId: null,
        type: '',
        s3Key: '',
        fileName: '',
        userId: 0,
        comment: '',
        registerDate: (new moment()).format('YYYY-MM-DD'),
      },
      dataNum: null,
      totalNum: null,
      error: '',
      registering: false,
      settings: [],
      settingChoice: {},
      modalTitle: '',
    }
  },
  methods: {
    // ファイル追加追加の処理
    handleFile: function() {
      const files = this.$refs.csvFile.files
      if (!files.length) {
        this.$set(this.form, 's3Key', '')
        this.$set(this.form, 'fileName', '')
      }
      this.error = ''
      for (let i = 0; files.length > i; i++) {
        const file = files[i]
        // ファイルの形式が違うのならerrorではじく
        if (file.type !== '') {
          if (file.type !== 'text/csv' && file.type !== 'text/tab-separated-values' && file.type !== 'application/vnd.ms-excel') {
            this.error = this.$t('ファイルの形式が異なります')
            this.$set(this.form, 'fileName', this.$t('必須メッセージ'))
            this.$set(this.form, 's3Key', '')
            break
          } else if (file.type === 'text/csv' || file.type === 'application/vnd.ms-excel') {
            this.$set(this.form, 'fileName', file.name.replace(/\.csv/g, ''))
          } else if (file.type === 'text/tab-separated-values') {
            this.$set(this.form, 'fileName', file.name.replace(/\.tsv/g, ''))
          }
        } else {
          if (file.name.match(/\.csv/g, '')) {
            this.$set(this.form, 'fileName', file.name.replace(/\.csv/g, ''))
          } else if (file.name.match(/\.tsv/g, '')) {
            this.$set(this.form, 'fileName', file.name.replace(/\.tsv/g, ''))
          } else {
            this.error = this.$t('ファイルの形式が異なります')
            this.$set(this.form, 'fileName', this.$t('必須メッセージ'))
            this.$set(this.form, 's3Key', '')
          }
        }
        this.mixinReadImportCSV(file, data => {
          this.totalNum = data.length

          const errMsg = this.$t('一度に登録できる件数は1,000件までです')
          if (this._dataNum > 1000) {
            this.error = errMsg
          } else if (this.error == errMsg) {
            this.error = ''
          }
        })
        this.$store.dispatch('file/put', {
          file: file,
          folder: 'partners',
        }).then(data => {
          const key = data.key
          if (key) {
            this.$set(this.form, 's3Key', key)
          }
        })
      }
    },
    getModalTitle(type) {
      if (type === 'partners')
        return this.$t('取引先データ取込')
      return this.$t('csv取込')
    },
    // モーダルを開いたときの処理
    async modalOpen(type) {
      this.form.type = type
      this.modalTitle = this.getModalTitle(type)

      this.$set(this.form, 'userId', this.userdata.id)
      this.$set(this.form, 'fileName', this.$t('必須メッセージ'))
      try {
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/import/settings`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params: {type: this.form.type},
          }
        )
        this.settings = res.data
      } catch (error) {
        this.$toasted.show(`${this.$t('データ取得エラーメッセージ')}`)
      }
      this.$refs.csvModal.show()
    },
    // モーダルを閉じるときの処理
    modalClose() {
      this.clearValue()
      this.$emit('modalClose')
      this.$refs.csvModal.hide()
    },
    // 値の初期化
    clearValue() {
      const file = document.getElementById('csvFile')
      file.value = ''
      for (let key of Object.keys(this.form)) {
        this.$set(this.form, key, defaultFormat[key])
      }
    },
    // 登録処理
    async register() {
      if (this.isEmpty(this.form.importSettingId)) {
        this.error = this.$t('ファイル') + this.$t('選択メッセージ')
        return
      } else if (this.isEmpty(this.form.fileName) || this.isEmpty(this.form.s3Key)) {
        this.error = this.$t('ファイル') + this.$t('選択メッセージ')
        return
      }
      this.error = ''
      this.registering = true
      let params = {}
      for (let key of Object.keys(this.form)) {
        params[key] = this.form[key]
      }
      try {
        await this.$axios.post(
          `${this.$appConfig.CommonApiUrl}/import`,
          params,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
        this.$emit('registered')
        this.clearValue()
        this.$refs.csvModal.hide()
        this.$toasted.success(`${this.$t('データ受付完了メッセージ')}${this.$t('取込状況は、データ一覧を参照して下さい')}`)
      } catch (error) {
        this.$toasted.show(`${this.$t('データ登録エラーメッセージ')}`)
      }
      this.registering = false
    },
  },
  computed: {
    setting() {
      if (this.settings.length === 0 || !this.form.importSettingId) return {}
      const setting = this.settings.filter(item => item.id === this.form.importSettingId)
      if (setting.length === 0) return {}
      return setting[0]
    },
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
    _dataNum() {
      if (this.form.importSettingId && this.form.s3Key && this.setting.id) {
        if (this.setting.importValues.length === 0 || this.totalNum === 0) {
          return 0
        } else if (this.setting.isHeader) {
          return this.totalNum - 1
        } else {
          return this.totalNum
        }
      } else {
        return null
      }
    },
    _error() {
      return this.error
    },
  },
}
</script>
